import { Reducer } from 'redux'
import { ISpecificLane } from '../routingGuide/types'
import { IMarketplaceStore } from '../types'
import { LANE_ALERTS_ACTION_TYPES as a } from './actions'
import * as Types from './types'

const initState = {
  data: undefined,
  loading: false,
  error: '',
}

interface ILaneAlertsResponsePayload {
  carrierMatches: Types.ICarrierMatch[]
  specificLane: ISpecificLane
}

interface ILaneAlertsRequest {
  type: a.FETCH_LANE_ALERTS_REQUEST
  payload: ILaneAlertsResponsePayload
}

interface ILaneAlertsSuccess {
  type: a.FETCH_LANE_ALERTS_SUCCESS
  payload: ILaneAlertsResponsePayload
}

interface ILaneAlertsFailure {
  type: a.FETCH_LANE_ALERTS_FAILURE
  error: string
  payload: ILaneAlertsResponsePayload
}

type LaneAlertsActions = ILaneAlertsRequest | ILaneAlertsSuccess | ILaneAlertsFailure

const laneAlertsReducer: Reducer<Types.ILaneAlertsState, LaneAlertsActions> = (
  state: Types.ILaneAlertsState = initState,
  action: LaneAlertsActions
): Types.ILaneAlertsState => {
  switch (action.type) {
    case a.FETCH_LANE_ALERTS_REQUEST: {
      return {
        ...state,
        loading: true,
        data: undefined,
      }
    }
    case a.FETCH_LANE_ALERTS_SUCCESS: {
      const {
        payload: { carrierMatches, specificLane },
      } = action as ILaneAlertsSuccess
      return {
        ...state,
        loading: false,
        data: {
          carrierMatches,
          specificLane,
        },
      }
    }
    default:
      return state
  }
}

export default laneAlertsReducer

/** Selectors */
export const selectLaneAlerts = (state: IMarketplaceStore): Types.ILaneAlerts | undefined =>
  state.laneAlerts.data

export const selectLaneAlertsRequestStatus = (state: IMarketplaceStore): boolean =>
  state.laneAlerts.loading
